import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationState } from '@feature/store/application-store';
import { Store, select } from '@ngrx/store';
import * as actions from '../actions/budget-vs-actual-config.actions';
import * as selectors from '../selectors/budget-vs-actual.selectors';
import * as configSelectors from '../selectors/budget-vs-actual-config.selectors';
import { EntityKeyService } from '@feature/pma-entity/services/entity-key.service';
import {
  BudgetVsActualConfigData
} from "@feature/_app_modules/budget-vs-actual/models/budget-vs-actual-config-data.model";

@Injectable()
export class BudgetVsActualConfigFacadeService {

    clearData(widgetConfigId: number){
      this.store.dispatch(actions.Clear({ widgetConfigId: widgetConfigId }));
    }

    selectIsLoading(widgetConfigId : number) : Observable<boolean> {
        return this.store.pipe(select(selectors.isLoading(widgetConfigId)));
    }

    dispatchConfigLoad(widgetConfigId: number) {
        this.store.dispatch(actions.BudgetConfigDataLoad({widgetConfigId: widgetConfigId}));
      }

      getDefaultPeriodSelection(widgetConfigId: number): Observable<string>{
        return this.store.pipe(select(configSelectors.getDefaultPeriodSelection(widgetConfigId)));
      }

      getDefaultViewSelection(widgetConfigId: number): Observable<string>{
        return this.store.pipe(select(configSelectors.getDefaultViewSelection(widgetConfigId)));
      }

      getNumberOfHierarchyLevels(widgetConfigId: number): Observable<number>{
        return this.store.pipe(select(configSelectors.getNumberOfHierarchyLevels(widgetConfigId)));
      }

    getSystemConfigSettings(widgetConfigId: number): Observable<BudgetVsActualConfigData>{
      return this.store.pipe(select(configSelectors.getData(widgetConfigId)));
    }

    constructor(
        protected entityKeyService: EntityKeyService,
        protected store: Store<ApplicationState>
    ) { }
}
